import AddToCollectionButton from './addtocollectionbutton'

export default AddToCollectionButton
